import React, { useState, createContext, useContext } from 'react';
// Create a context for language state
const LanguageContext = createContext({
  language: 'en',
  toggleLanguage: () => {}
});
// Create a provider component
export const LanguageProvider = ({
  children
}) => {
  const [language, setLanguage] = useState('en');
  const toggleLanguage = () => {
    setLanguage(language === 'en' ? 'vi' : 'en');
  };
  return <LanguageContext.Provider value={{
    language,
    toggleLanguage
  }} data-id="element-544">
      {children}
    </LanguageContext.Provider>;
};
// Create a custom hook to use the language context
export const useLanguage = () => useContext(LanguageContext);
export default LanguageContext;